import React, { useState, useEffect, useRef, use } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus, faSearch, faEye, faEdit, faTrash, faFilter,
  faBox, faStore, faUsers, faChevronDown, faX,
  faPaperclip,
  faUserPlus,
  faExclamationTriangle,
  faInfoCircle,
  faUser,
  faSliders
} from '@fortawesome/free-solid-svg-icons';
import AssignProductsModal from './AssignProductsModal';
import ViewAssignedProducts from './ViewAssignedProducts';
import { Msg200or201, Msg204, Msg400, Msg401, Msg403, Msg500 } from '../Messages/Messages';
import { useNavigate } from 'react-router-dom';
import { decryptData } from '../../utils/storageCrypto';

const SupplierProductDashboard = () => {
  const navigate = useNavigate();
  const supplierRefs = useRef({}); // Ref to store supplier element references
  const supplierContainerRef = useRef(null); // Ref for the supplier container
  const [isSaving, setIsSaving] = useState(false);
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [popupType, setPopupType] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [retryFunction, setRetryFunction] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [filteredSuppliers, setFilteredSuppliers] = useState([]); // Add filtered suppliers state
  const [supplierSearchTerm, setSupplierSearchTerm] = useState(''); // Add supplier search term
  const [categorysVendorItemsCount, setCategorysVendorItemsCount] = useState({});
  const [productCategories, setProductCategories] = useState([]);
  const [PC_Products, setPC_Products] = useState([]);
  const [supplierCategoryProducts, setSupplierCategoryProducts] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [showAssignCategoryPopup, setShowAssignCategoryPopup] = useState(false);
  const [categoryToAssign, setCategoryToAssign] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

const [showMovsPopup, setShowMovsPopup] = useState(false);                     
const [movsCategory, setMovsCategory] = useState(null); 
const [rows, setRows] = useState([]);
const [subCategories, setSubCategories] = useState([]);
const [loadingSubCategories, setLoadingSubCategories] = useState(false);
const [loading, setLoading] = useState(false);
const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
const [deleteRowIndex, setDeleteRowIndex] = useState(null);


  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [allProducts, setAllProducts] = useState([]);
    const [categories,setCategories] = useState([]);
    const [showDiscountPopup, setShowDiscountPopup] = useState(false);
    const [attributes, setAttributes] = useState([]);
    const [deleteConfirmed, setDeleteConfirmed] = useState({
      show: false,
      index: null
    });
    const buttonRefs = useRef([]);
const [openDropdownIndex, setOpenDropdownIndex] = useState({ 
  sectionIndex: null 
}); 

const [dropdownStyle, setDropdownStyle] = useState({});
    const [categoryRowsMap, setCategoryRowsMap] = useState({});
      const [vendorCategories,setVendorCategories] = useState([]);
  const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
      const [selectedCategories, setSelectedCategories] = useState({});
      const [selectedVendor, setSelectedVendor] = useState(null);
      const [selectedSubCategory, setSelectedSubCategory] = useState("");
      const [savedSlabs, setSavedSlabs] = useState({});
      const [isDiscountLoading, setIsDiscountLoading] = useState(false);
      
      
      
      
    const getDefaultRow = () => ({
  mov: "",
  discount: "",
  attributes: [],           // ✅ EMPTY
  attributeIds: [],         // ✅ EMPTY  
  open: false,
  isExisting: false         // ✅ NEW ROW
});

  const [slabSections, setSlabSections] = useState([
    {
      id: Date.now(),
      rows: [getDefaultRow()]
    }
  ]);

useEffect(() => {
  if (openDropdownIndex === null) {
    setDropdownStyle({});
  }
}, [openDropdownIndex]);

useEffect(() => {
  if (selectedVendor && selectedCategory && slabSections.length > 0) {
    setSavedSlabs(prev => ({
      ...prev,
      [selectedVendor._id]: {
        ...prev[selectedVendor._id],
        [selectedCategory]: {
          ...prev[selectedVendor._id]?.[selectedCategory],

          ...(selectedSubCategory
            ? {
                [selectedSubCategory]: slabSections
              }
            : {
                "__category__": slabSections
              })
        }
      }
    }));
  }
}, [slabSections]);

  // Filter suppliers based on search term
  useEffect(() => {
  if (!supplierSearchTerm.trim()) {
    setFilteredSuppliers(suppliers);
  } else {
    const term = supplierSearchTerm.toLowerCase();

    const filtered = suppliers.filter((supplier) => {

      // supplier search
      const supplierMatch =
        supplier.name?.toLowerCase().includes(term) ||
        supplier.company_name?.toLowerCase().includes(term) ||
        supplier.mobile_number?.toString().includes(term);

      // item search
      const itemMatch = allProducts?.some(
        (product) =>
          product.product_name?.toLowerCase().includes(term) &&
          String(product.vendor_id?._id) === String(supplier._id)
      );

      return supplierMatch || itemMatch;
    });

    setFilteredSuppliers(filtered);
  }
}, [supplierSearchTerm, suppliers, allProducts]);


useEffect(() => {
  const handleClick = () => {
    setOpenDropdownIndex(null);
  };

  window.addEventListener("click", handleClick);
  return () => window.removeEventListener("click", handleClick);
}, []);


useEffect(() => {
  if (showDiscountPopup && selectedVendor?._id) {
    console.log("🔥 Fetching discount for vendor:", selectedVendor._id);
    fetchDiscountSlabsByVendor();
  }
}, [showDiscountPopup, selectedVendor]); // ✅ ADD THIS

// const [discountrows, setDiscountRows] = useState([]);

useEffect(() => {
  if (openDropdownIndex !== null) {
    const rect = buttonRefs.current[openDropdownIndex]?.getBoundingClientRect();

    if (rect) {
      setDropdownStyle({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX
      });
    }
  }
}, [rows, openDropdownIndex]); // 🔥 IMPORTANT

// const addedRow = () => {
//   setDiscountRows([
//     ...discountrows,
//     {
//       mov: "",
//       discount: "",
//       attributes: [],
//       attributeIds: [],
//       open: false,
//       isExisting: false // ✅ NEW ROW
//     }
//   ]);
// };

  // Scroll to selected supplier
  const scrollToSupplier = (supplierId) => {
    const supplierElement = supplierRefs.current[supplierId];
    const container = supplierContainerRef.current;
    
    if (supplierElement && container) {
      const containerRect = container.getBoundingClientRect();
      const elementRect = supplierElement.getBoundingClientRect();
      
      // Calculate the scroll position to center the element in the container
      const scrollTop = supplierElement.offsetTop - container.offsetTop - (containerRect.height / 2) + (elementRect.height / 2);
      
      container.scrollTo({
        top: Math.max(0, scrollTop),
        behavior: 'smooth'
      });
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // Fetch suppliers
        const QuickBuySuppliers = await FetchQuickBuySuppliers();
        if (QuickBuySuppliers && QuickBuySuppliers.length > 0) {
          setSuppliers(QuickBuySuppliers);
          setFilteredSuppliers(QuickBuySuppliers);
          handleSupplierSelect(QuickBuySuppliers[0]);
        } else {
          setSuppliers([]);
          setFilteredSuppliers([]);
        }

        // Fetch product categories
        const QuickBuyProductCategories = await FetchQuickBuyProductCategories();
        if (QuickBuyProductCategories && QuickBuyProductCategories.length > 0) {
          setProductCategories(QuickBuyProductCategories);
        } else {
          setProductCategories([]);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        //setSuppliers([]);
        //setFilteredSuppliers([]);
        //setProductCategories([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    fetchGetAllProducts();
  }, []);


  useEffect(() => {
  if (showMovsPopup && selectedSupplier?._id && movsCategory?._id) {
    fetchMOVs();
  }
}, [showMovsPopup, selectedSupplier, movsCategory]);

const handleAddSlabSection = () => {
  setSlabSections(prev => [
    ...prev,
    {
      id: Date.now(),
      rows: [getDefaultRow()]
    }
  ]);
};

const handleRowChange = (sectionIndex, rowIndex, field, value) => {
  setSlabSections(prevSections =>
    prevSections.map((section, sIndex) =>
      sIndex === sectionIndex
        ? {
            ...section,
            rows: section.rows.map((row, rIndex) =>
              rIndex === rowIndex ? { ...row, [field]: value } : row
            )
          }
        : section
    )
  );
};

const addRow = (sectionIndex) => {
  setSlabSections(prevSections =>
    prevSections.map((section, sIndex) =>
      sIndex === sectionIndex
        ? {
            ...section,
            rows: [
              ...section.rows,
              {
                ...getDefaultRow(),

                // ✅ COPY attributes from first row (or last row)
                attributes: section.rows[0]?.attributes || [],
                attributeIds: section.rows[0]?.attributeIds || []
              }
            ]
          }
        : section
    )
  );
};

const getSubCategoryName = (subCategoryId) => {
  if (!subCategoryId) return "Category Level";
  
  const subCat = subCategories.find(sub => sub._id === subCategoryId);
  return subCat?.product_sub_category_name || "Unknown Subcategory";
};

  // When calling the function
  const handleSupplierSelect = async (supplier) => {
    setSelectedSupplier(supplier);
    // setIsLoading(true);
    
    // Scroll to the selected supplier
    // setTimeout(() => {
    //   scrollToSupplier(supplier._id);
    // }, 100);
    
    try {
      const result = await FetchVendorAssignedCategoryItemsCount(supplier);
      
      if (result.success) {
        console.log('Vendor category items loaded successfully');
        // Additional success handling if needed
      } else {
        console.log('Failed to load vendor category items:', result.error);
        // Error is already handled in the function
      }
    } catch (error) {
      console.error('Unexpected error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Clear supplier search
  const clearSupplierSearch = () => {
    setSupplierSearchTerm('');
  };

  const fetchGetAllProducts = async () => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);
      const encryptedhubId = sessionStorage.getItem('hubId');
      const hubId = decryptData(encryptedhubId);  
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await fetch(`${fetchUrl}product/get-all-products?hubId=${hubId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.message || 'Unknown error'}`);
      }
      const data = await response.json();
      console.log('Fetched all products:', data);
      if (!data.success) {
        throw new Error(data.message || 'Failed to fetch products');
      }
      setAllProducts(data.data);
      return data.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  };


  // Rest of your existing functions remain the same...
  const FetchVendorAssignedCategoryItemsCount = async (supplier) => {
    try {
      // Validate supplier parameter
      if (!supplier || !supplier._id) {
        throw new Error('Invalid supplier data provided');
      }

      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${fetchUrl}product/get-vendor-product-categories-count?vendor_id=${supplier._id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });

      // Check if response is ok
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.message || 'Unknown error'}`);
      }

      const data = await response.json();
      console.log('Vendor category items loaded successfully', data);
      // Validate response structure
      if (!data) {
        throw new Error('No data received from server');
      }

      // Check if the API call was successful
      if (data.success === false) {
        throw new Error(data.message || 'API call failed');
      }

      // Validate data structure
      if (!data.data) {
        throw new Error('Invalid response structure: missing data field');
      }

      // Set the data
      setCategorysVendorItemsCount(data.data);
      
      // Return success result
      return {
        success: true,
        data: data.data
      };

    } catch (error) {
      console.error('Error fetching vendor category items:', error);
      
      // Handle different types of errors
      if (error.message.includes('401') || error.message.includes('authentication')) {
        // Handle authentication errors
        setPopupMessage('Session expired. Please login again.');
        setPopupType('401');
        setShowPopup(true);
      } else if (error.message.includes('403')) {
        // Handle authorization errors
        setPopupMessage('You do not have permission to access this data.');
        setPopupType('403');
        setShowPopup(true);
      } else if (error.message.includes('404')) {
        // Handle not found errors
        setPopupMessage('No data found for this vendor.');
        setPopupType('404');
        setShowPopup(true);
      } else if (error.message.includes('500')) {
        // Handle server errors
        setPopupMessage('Server error. Please try again later.');
        setPopupType('500');
        setShowPopup(true);
      } else {
        // Handle other errors
        setPopupMessage(error.message || 'Failed to fetch vendor category items');
        setPopupType('400');
        setShowPopup(true);
      }
      
      // Reset the state on error
      setCategorysVendorItemsCount(null);
      
      // Return error result
      return {
        success: false,
        error: error.message
      };
    }
  };

  // ... (rest of your existing functions remain unchanged)

  const FetchQuickBuySuppliers = async () => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${fetchUrl}vendor/get-quick-buy-suppliers`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (!data.success) {
        throw new Error(data.message || 'Failed to fetch suppliers');
      }
      console.log('Fetched suppliers:', data.data);
      return data.data;
    } catch (error) {
      console.error('Error fetching suppliers:', error);
      throw error;
    }
  };

  const FetchQuickBuyProductCategories = async () => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);


      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${fetchUrl}product-category/get-quick-buy-product-categories`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response body:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching product categories:', error);
      throw error;
    }
  };

  const FetchQuickBuyProductsByCategory = async (id) => {
    try {
      setIsLoading(true);
     const encryptedToken = sessionStorage.getItem('token');
     const token = decryptData(encryptedToken);

      
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${fetchUrl}product/get-products-data-by-product-category?product_category_id=${id}&vendor_id=${selectedSupplier._id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      });

      const data = await response.json();
      const output = await getResponseHandling(response, data);
      
      if (output) {
        setPC_Products(output);
      } else {
        setPC_Products([]);
      }
    } catch (error) {
      console.error('Error fetching products by category:', error);
      setPC_Products([]);
    } finally {
      setIsLoading(false);
      setShowAssignModal(true);
    }
  };

/*   const filteredCategories = productCategories.filter(category => {
    const matchesSearch = category?.product_category_name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterStatus === 'all' ||
      (filterStatus === 'ecommerce' && category.is_ecommerce) ||
      (filterStatus === 'non-ecommerce' && !category.is_ecommerce);

    return matchesSearch && matchesFilter;
  }); */

  const filteredCategories = productCategories.filter((category) => {
  const categoryName = category?.product_category_name?.toLowerCase() || '';
  console.log('category ', category);
  const searchValue = searchTerm?.toLowerCase() || '';

  const matchesSearch = categoryName.includes(searchValue);

  const matchesFilter =
    filterStatus === 'all' ||
    (filterStatus === 'ecommerce' && category?.is_ecommerce) ||
    (filterStatus === 'non-ecommerce' && !category?.is_ecommerce);

  return matchesSearch && matchesFilter;
});

  const getAssignedProductsCount = (categoryId) => {
    // Validate inputs
    if (!categoryId) {
      return 0;
    }

    if (!categorysVendorItemsCount) {
      return 0;
    }

    // Check if productCategorys array exists (note: it's "productCategorys" not "productCategories")
    if (!categorysVendorItemsCount.productCategorys || !Array.isArray(categorysVendorItemsCount.productCategorys)) {
      return 0;
    }

    // Find the category count (note: field name is "items_count" not "count")
    const categoryCount = categorysVendorItemsCount.productCategorys.find(
      count => count.product_category_id === categoryId
    );

    return categoryCount?.items_count || 0;
  };

  const handleAssignProducts = async (category) => {
    setSelectedCategory(category);
    await FetchQuickBuyProductsByCategory(category._id);
  };

  const handleViewProducts = async (category) => {
    setSelectedCategory(category);
    await getProductsByVendorAndCategory(selectedSupplier._id, category._id);
  };

  const handleAssignmentComplete = async (newAssignment) => {
    console.log('Completing assignment:', newAssignment);
    
    try {
      // Show loading state
      setIsLoading(true);
      
      // Transform the assignment data to match backend expectations
      const transformedAssignment = transformAssignmentForBackend(newAssignment);
      
      // Call the API to assign items to supplier
      const result = await assignItemsToSupplier(transformedAssignment);
      
      if (result.success) {
        // Show success message
        setPopupMessage('Products assigned to supplier successfully!');
        setPopupType('200or201');
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
        }, 2000);
        // Refresh the supplier products data
        //await fetchSupplierProducts();
        
        // Close the modal
          const QuickBuySuppliers = await FetchQuickBuySuppliers();
          setSuppliers(QuickBuySuppliers);
        await FetchVendorAssignedCategoryItemsCount(selectedSupplier);
       
        
      } else {
        // Show error message
        setPopupMessage(result.error || 'Failed to assign products to supplier');
        setPopupType('400');
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Error in handle AssignmentComplete:', error);
      setPopupMessage('An unexpected error occurred while assigning products');
      setPopupType('500');
      setShowPopup(true);
    } finally {
      setIsLoading(false);
      setShowAssignModal(false);
    }
  };

    const transformAssignmentForBackend = (assignment) => {
    // Transform the frontend assignment data to match backend expectations
    const transformedItems = assignment.assigned_products.map(product => ({
      id: product.product_id, // Backend expects 'id', not 'product_id'
      price: product.selling_price, // Backend expects 'price'
      SKU_Code: product.SKU_Code, // Backend expects 'SKU_code'
      Moqs: product.moqs || [] // Backend expects 'Moqs' (capital M)
    }));

    return {
      vendor_id: assignment.vendor_id, // Backend expects 'vendor_id'
      pc_items: [{
        product_category_id: assignment.product_category_id,
        items: transformedItems
      }]
    };
  };

  const assignItemsToSupplier = async (assignmentData) => {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    
    try {
      console.log('Sending assignment data to backend:', assignmentData);
      
      const response = await fetch(`${fetchUrl}product/assign-vendor-to-products`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify(assignmentData)
      });

      const data = await response.json();
      console.log('Backend response:', data);

      if (response.ok) {
        return {
          success: true,
          data: data,
          message: data.message || 'Items assigned to supplier successfully',
          results: data // Include the results from backend
        };
      } else {
        // Handle different error status codes
        let errorMessage = data.message || 'Failed to assign items to supplier';
        
        switch (response.status) {
          case 400:
            errorMessage = data.message || 'Invalid request data';
            break;
          case 401:
            errorMessage = 'Authentication failed. Please login again.';
            break;
          case 403:
            errorMessage = 'You do not have permission to perform this action';
            break;
          case 500:
            errorMessage = 'Server error. Please try again later.';
            break;
          default:
            errorMessage = `Error ${response.status}: ${data.message || 'Unknown error'}`;
        }

        return {
          success: false,
          error: errorMessage,
          status: response.status,
          details: data
        };
      }
    } catch (error) {
      console.error('Error assigning items to supplier:', error);
      
      // Handle different types of network errors
      let errorMessage = 'Network error or server unavailable';
      
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        errorMessage = 'Unable to connect to server. Please check your internet connection.';
      } else if (error.name === 'SyntaxError') {
        errorMessage = 'Invalid response from server. Please try again.';
      }

      return {
        success: false,
        error: errorMessage,
        details: error.message
      };
    }
  };

  const getProductsByVendorAndCategory = async (vendorId, productCategoryId) => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

      console.log('Vendor ID:', vendorId, 'token:', token);
      if (!token) {
        throw new Error('No authentication token found');
      }

      if (!vendorId || !productCategoryId) {
        throw new Error('Vendor ID and Product Category ID are required');
      }
      
      const response = await fetch(
        `${fetchUrl}product/get-quick-buy-products-by-vendor-category?vendor_id=${vendorId}&product_category_id=${productCategoryId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.message || 'Unknown error'}`);
      }

      const data = await response.json();
      console.log('Response data:', data);
      if (!data.success) {
        setSupplierCategoryProducts([])
        throw new Error(data.message || 'API call failed');
      }

     setSupplierCategoryProducts(data.data.products);

    } catch (error) {
      console.error('Error fetching products by vendor and category:', error);
      setSupplierCategoryProducts([]);
      return {
        success: false,
        error: error.message
      };
      
    }finally {
      setShowViewModal(true);
      setIsLoading(false);
    }
  };

  const getResponseHandling = async (response, data) => {
    if (response.ok) {
      if (response.status === 200 || response.status === 201) {
        setPopupType('200or201');
        return data.data;
      } else if (response.status === 204) {
        setPopupType('204');
        return data.data;
      }
    } else {
      if (response.status === 400) {
        setPopupType('400');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null;
      } else if (response.status === 401) {
        setPopupType('401');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null;
      } else if (response.status === 403) {
        setPopupType('403');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null;
      } else if (response.status === 500) {
        setPopupType('500');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null;
      } else {
        setErrorMessages([...errorMessages, data.message]);
      }
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const BackToLoginPage = () => {
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
    navigate('/bb');
  };

  const handleNavigateToCreateVendor = ()=>{
    navigate('/bb/app/purchases/newvendor');
  }

  const handleEditSupplier = () => {
  navigate('/bb/app/purchases/EditVendor',  {state:{VendorData:selectedSupplier}});
  console.log(selectedSupplier);
}

 const handleAssignCategoryToSupplier = (category) => {
  setCategoryToAssign(category);
  setShowAssignCategoryPopup(true);
};

const handleMovsClick = (category) => {
  setMovsCategory(category);
  setShowMovsPopup(true);
    fetchSubCategories(category._id); // ✅ CALL SUBCATEGORY API

};

/* const handleConfirmAssignCategory = () => {
  // Handle the actual assignment here
  console.log('Assigning category to supplier:', categoryToAssign, selectedSupplier);
  // Call your API here
  // assignCategoryToSupplier(selectedSupplier._id, categoryToAssign._id);
  
  // Close popup and reset state
  setShowAssignCategoryPopup(false);
  setCategoryToAssign(null);
}; */


const fetchSubCategories = async (categoryId) => {
  try {
    setLoadingSubCategories(true);
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}product-category/get-all-subcategories-and-UOMs-under-product-category?product_category_id=${categoryId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const data = await response.json();
    console.log("Subcategories response:", data);

    if (data.status === 200 && Array.isArray(data?.data?.subCategories)) {
      setSubCategories(data.data.subCategories);
    } else {
      setSubCategories([]);
    }
  } catch (err) {
    console.error("Subcategory fetch failed", err);
    setSubCategories([]);
  } finally {
    setLoadingSubCategories(false);
  }
};

const deleteRow = async (rowIndex) => {
  const row = rows[rowIndex];
  if (!row) return;

  if (!row._categoryMovId) {
    setRows(prev => prev.filter((_, i) => i !== rowIndex));
    return;
  }

  const categoryDeletes = [{
    document_id: row._categoryMovId,
    mov: Number(row.mov)
  }];

  const subcategoryDeletes = Object.entries(row.subcategoryMovIds || {}).map(
    ([_, docId]) => ({
      document_id: docId,
      mov: Number(row.mov)
    })
  );

  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    const response = await fetch(`${fetchUrl}movs/delete-movs`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify({
        category_deletes: categoryDeletes,
        subcategory_deletes: subcategoryDeletes
      })
    });

    const data = await response.json();

    if (response.ok && data.success) {
      setRows(prev => prev.filter((_, i) => i !== rowIndex));
      setPopupType('200or201');
      setPopupMessage('MOV deleted successfully');
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 2000);
    } else {
      setPopupType('400');
      setPopupMessage(data.message || 'Failed to delete MOV');
      setShowPopup(true);
    }
  } catch (error) {
    console.error('Error deleting MOV:', error);
    setPopupType('500');
    setPopupMessage('Something went wrong while deleting MOV');
    setShowPopup(true);
  }
};


const handleConfirmAssignCategory = async (attempt = 1) => {
  setIsSaving(true);
   const ReminingProductCategories = selectedSupplier.productCategories?.map((category) => category._id) || [];
const selectedCategoriesToassign = {
  vendor_id: selectedSupplier._id,
  product_category_ids: [...ReminingProductCategories, categoryToAssign._id],
};


  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    const response = await fetch(`${fetchUrl}product-category/assign-productCategory-to-vendor?vendor_id=${selectedSupplier._id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify(selectedCategoriesToassign),
    });

    const data = await response.json();
    
    if (data.status === 201 || data.status === 200 || data.status === 204) {
      setIsSaving(false);
      setPopupType('200or201');
      setPopupMessage(data.message || `Category "${categoryToAssign.product_category_name}" assigned to supplier "${selectedSupplier.name}" successfully`);
      setShowPopup(true);
      
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);

      // Update the selected supplier's product categories
      if (selectedSupplier && categoryToAssign) {
        const updatedSupplier = {
          ...selectedSupplier,
          productCategories: [
            ...(selectedSupplier.productCategories || []),
            {
              _id: categoryToAssign._id,
              product_category_name: categoryToAssign.product_category_name
            }
          ],
          totalProductCategories: (selectedSupplier.totalProductCategories || 0) + 1
        };
        
        // Update the supplier in your suppliers list
        setSuppliers(prevSuppliers => 
          prevSuppliers.map(supplier => 
            supplier._id === selectedSupplier._id ? updatedSupplier : supplier
          )
        );
        
        // Update selected supplier
        setSelectedSupplier(updatedSupplier);
      }

      // Close popup and reset state
      setShowAssignCategoryPopup(false);
      setCategoryToAssign(null);
      
    } else if (response.status === 500) {
      setIsSaving(false);
      setPopupType('500');
      setRetryFunction(() => () => handleConfirmAssignCategory(attempt));
      setPopupMessage(data.message);
      setShowPopup(true);
    } else {
      setIsSaving(false);
      setPopupType(`${data.status}`);
      setPopupMessage(data.message);
      setShowPopup(true);
    }
  } catch (error) {
    console.error('Failed to assign category:', error);
    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1);
      setTimeout(() => handleConfirmAssignCategory(attempt + 1), 1000);
    } else {
      setIsSaving(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => handleConfirmAssignCategory(attempt));
    }
  }
};

const handleUpdateViewAssignedProducts = async () => {
  await getProductsByVendorAndCategory(selectedSupplier._id, selectedCategory._id);
}
const handleRemoveAssignedProduct = async()=>{
  const QuickBuySuppliers = await FetchQuickBuySuppliers();
 if (QuickBuySuppliers && QuickBuySuppliers.length > 0) {
          setSuppliers(QuickBuySuppliers);
          setFilteredSuppliers(QuickBuySuppliers);
        }
  await handleSupplierSelect(selectedSupplier);
  await getProductsByVendorAndCategory(selectedSupplier._id, selectedCategory._id);
}

const handleCancelAssignCategory = () => {
  setShowAssignCategoryPopup(false);
  setCategoryToAssign(null);
};



const handleApply = (rowIndex) => {
  const categoryDiscount = rows[rowIndex].category_discount;
  setRows(prev => prev.map((r, i) => {
    if (i === rowIndex) {
      const newSubDiscounts = { ...r.subcategory_discounts };
      subCategories.forEach(sub => {
        newSubDiscounts[sub._id] = categoryDiscount;  
      });
      return { ...r, subcategory_discounts: newSubDiscounts, applied: true };  
    }
    return r;
  }));
};

  const Retry = async () => {
    setTimeout(async () => {
      if (retryFunction) {
        await retryFunction();
      }
      setIsLoading(false);
    }, 1000);

    setShowPopup(false);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

 const toggleCheckbox = (index) => {
  setRows(prev => {
    if (!Array.isArray(prev)) return [];
    return prev.map((row, i) =>
      i === index ? { ...row, checked: !row.checked } : row
    );
  });
};


// const deleteRow = (index) => {
//   setRows(prev => {
//     if (!Array.isArray(prev)) return [];
//     return prev.filter((_, i) => i !== index);
//   });
// };


const fetchMOVs = async () => {
  try {
   const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);


    const res = await fetch(
      `${fetchUrl}movs/get-movs-by-vendorid?vendor_id=${selectedSupplier._id}`,
      {
        headers: {
          'x-token': token
        }
      }
    );

    const json = await res.json();
    if (!res.ok) {
      setRows([]);
      return;
    }

    const { categories = [], subcategories = [] } = json.data;

    // Debug: Log the full API response to inspect structure
    console.log('API Response - Categories:', categories);
    console.log('API Response - Subcategories:', subcategories);

    // 1️⃣ Category MOVs for selected category
    const categoryMOV = categories.find(
      c => c.product_category_id === movsCategory._id
    );

    if (!categoryMOV) {
      setRows([]);
      return;
    }

    // 2️⃣ Build rows from category MOVs
    const rowsData = categoryMOV.movs.map(movItem => {
      const discount = movItem.discount || 0;
      const row = {
        _categoryMovId: categoryMOV._id,
        mov: movItem.mov,
        category_discount: discount,
        subcategory_discounts: {},
        subcategoryMovIds: {}, // Added: To store subcategory document IDs for deletion
        applied: discount !== 0  
      };

      // 3️⃣ Merge subcategory MOVs having SAME mov
      subcategories.forEach(sub => {
        const subMov = sub.movs.find(m => m.mov === movItem.mov);
        if (subMov) {
          row.subcategory_discounts[sub.product_sub_category_id] =
            subMov.discount;
          row.subcategoryMovIds[sub.product_sub_category_id] = sub._id; // Added: Store the document ID for deletion
        }
      });

      return row;
    });

    // Debug: Log the built rowsData to check if subcategoryMovIds is populated
    console.log('Built Rows Data:', rowsData);

    setRows(rowsData);

  } catch (err) {
    console.error('Error fetching MOVs', err);
    setRows([]);
  }
};



const handleSave = async () => {
  try {
    const categoriesPayload = [];
    const subCategoriesPayload = [];

    rows.forEach(row => {
      /* ---------------- CATEGORY LEVEL ---------------- */
      if (row.category_discount !== '' && row.category_discount !== null) {
        categoriesPayload.push({
          _id: row._categoryMovId || null, // optional, if editing
          vendor_id: selectedSupplier._id,
          product_category_id: movsCategory._id,
          movs: [
            {
              mov: Number(row.mov),
              discount: Number(row.category_discount)
            }
          ]
        });
      }

      /* ---------------- SUBCATEGORY LEVEL ---------------- */
      Object.entries(row.subcategory_discounts || {}).forEach(
        ([subCategoryId, discount]) => {
          if (discount !== '' && discount !== null) {
            subCategoriesPayload.push({
              vendor_id: selectedSupplier._id,
              product_sub_category_id: subCategoryId,
              movs: [
                {
                  mov: Number(row.mov),
                  discount: Number(discount)
                }
              ]
            });
          }
        }
      );
    });

    const payload = {
      categories: categoriesPayload,
      subcategories: subCategoriesPayload
    };

    console.log(payload)

    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);


    const res = await fetch(
      `${fetchUrl}movs/create-or-update-mov`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify(payload)
      }
    );

    const json = await res.json();

   if (!res.ok) {
      console.error(json);
      setPopupType('400'); 
      setPopupMessage('Failed to save MOV');
      setShowPopup(true);
      return;
    }

    // Success
    setPopupType('200or201');
    setPopupMessage('MOV saved successfully');
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
      setShowMovsPopup(false); 
    }, 2000);

  } catch (err) {
    console.error('Save error', err);
    setPopupType('500');
    setPopupMessage('Something went wrong');
    setShowPopup(true);
  }
};


const fetchProductCategories = async (attempt = 1) => {
  try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

      const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + "product-category/get-all-productCategories", {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              'x-token':token
          }
      });
      const data = await response.json();
      console.log('product category data', data);
      if (data.status === 200 || data.status === 201 || data.status === 204) {
        setCategories(data.data); 
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setPopupMessage(data.message);
        setPopupType(`${data.status}`);
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
  
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchProductCategories(attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchProductCategories(attempt)); // Set retry function
      }
    }
  };


 const fetchAttributesByCategory = async (categoryId, subCategoryId = null) => {
   if (!categoryId) return;
 
   console.log("🚀 Fetching Attributes for:", { categoryId, subCategoryId });
 
   try {
     const encryptedToken = sessionStorage.getItem('token');
     const token = decryptData(encryptedToken);
 
     const url = `${backendApiUrl}product-attributes/get-attr?product_category_id=${categoryId}&product_sub_category_id=${subCategoryId}`;
 
     const res = await fetch(url, {
       method: 'GET',
       headers: {
         Accept: 'application/json',
         'x-token': token
       }
     });
 
     const data = await res.json();
     console.log('📦 Attributes API Response:', data);
 
     if (data.success) {
       const attrList = data.data || [];
 
       // ✅ 1. SET GLOBAL ATTRIBUTES
       setAttributes(attrList);
 
       // ✅ 2. MAP EXISTING ATTRIBUTE IDS → VALUES (MAIN FIX)
       setSlabSections(prevSections =>
         prevSections.map(section => ({
           ...section,
           rows: section.rows.map(row => {
             const mappedAttributes = attrList
               .flatMap(attr => attr.attribute_values || [])
               .filter(val => row.attributeIds?.includes(val.attribute_value_id))
               .map(val => ({
                 id: val.attribute_value_id,
                 name: val.attribute_value
               }));
 
             return {
               ...row,
               attributes: mappedAttributes
             };
           })
         }))
       );
     }
 
   } catch (error) {
     console.error("❌ Error fetching attributes:", error);
   }
 };
 


   const fetchProductCategoriesOfSelectedVendor = async (supplier, attempt = 1) => {
      try {
        const encryptedToken = sessionStorage.getItem('token');
                  const token = decryptData(encryptedToken);
  
        const response = await fetch(`${backendApiUrl}product-category/get-productCategoriesBy-vendor_id?vendor_id=${supplier?._id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
        const data = await response.json();
        console.log('Vendor categories data:', data);
    
        if (data.status === 200 || data.status === 201 || data.status === 204) {
          if (Array.isArray(data.data)) {
            const assignedCategoryIds = data.data.map(category => category._id);
            setVendorCategories(assignedCategoryIds);
            console.log('Assigned category IDs:', assignedCategoryIds);
          } else if (data.status === 404) {
            console.error('Unexpected response format:', data);
            setVendorCategories([]);
            setSelectedCategories({});
          }
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setPopupMessage(data.message || 'An error occurred');
          setPopupType(`${data.status}`);
          setShowPopup(true);
        }
      } catch (error) {
        console.error('Failed to fetch:', error);
        if (attempt < RETRY_LIMIT) {
          setRetryCount(attempt + 1); // Increment retry count
          setTimeout(() => fetchProductCategoriesOfSelectedVendor(suppliers, attempt + 1), 1000); // Retry after 1 second
        } else {
          setIsLoading(false);
          setPopupMessage('Internal Server Error. Kindly Retry.');
          setPopupType('500');
          setShowPopup(true);
          setRetryFunction(() => () => fetchProductCategoriesOfSelectedVendor(suppliers, attempt)); // Set retry function
        }
      }
    };




const handleSaveDiscountSlabs = async () => {
  try {
    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);

    // ✅ Validate
    for (let sectionIndex = 0; sectionIndex < slabSections.length; sectionIndex++) {
      for (let rowIndex = 0; rowIndex < slabSections[sectionIndex].rows.length; rowIndex++) {
        const row = slabSections[sectionIndex].rows[rowIndex];
        if (!row.mov || Number(row.mov) <= 0) {
          setPopupMessage("Please enter a MOV value for all rows.");
          setPopupType("400");
          setShowPopup(true);
          return;
        }
      }
    }

    // ✅ CHECK subcategory
    const isSubCategory = !!selectedSubCategory;

    // ✅ BUILD PAYLOAD
    const payload = {
      categories: !isSubCategory
        ? slabSections.flatMap(section =>
            section.rows.map(row => ({
              vendor_id: selectedVendor?._id,
              product_category_id: selectedCategory,
              product_sub_category_id: null,
              attribute_value_ids: row.attributes?.map(attr => attr.id) || [],
              movs: [{
                mov: Number(row.mov),
                discount: Number(row.discount || 0)
              }]
            }))
          )
        : [],

      subcategories: isSubCategory
        ? slabSections.flatMap(section =>
            section.rows.map(row => ({
              vendor_id: selectedVendor?._id,
              product_category_id: selectedCategory,
              product_sub_category_id: selectedSubCategory,
              attribute_value_ids: row.attributes?.map(attr => attr.id) || [],
              movs: [{
                mov: Number(row.mov),
                discount: Number(row.discount || 0)
              }]
            }))
          )
        : []
    };

    console.log("🔥 FINAL PAYLOAD:", JSON.stringify(payload, null, 2));

    const res = await fetch(
      `${backendApiUrl}discount/create-or-update-discountslab`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify(payload)
      }
    );

    const data = await res.json();

    if (data.status === 200 || data.status === 201) {
      setPopupMessage("Discount slabs saved successfully ✅");
      setPopupType('200or201');
      setShowPopup(true);

      setTimeout(() => {
        fetchDiscountSlabsByVendor();
        setShowDiscountPopup(false);
        setShowPopup(false);
      }, 1500);

    } else {
      setPopupMessage(data.message || "Failed to save");
      setPopupType(`${data.status}`);
      setShowPopup(true);
    }

  } catch (error) {
    console.error("Save error:", error);
    setPopupMessage("Network error. Please try again.");
    setPopupType("500");
    setShowPopup(true);
  }
};


const fetchDiscountSlabsByVendor = async () => {
  try {
    setIsDiscountLoading(true);
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const res = await fetch(
      `${backendApiUrl}discount/get-discountslabs-by-vendorid?vendor_id=${selectedVendor?._id}`,
      { method: "GET", headers: { "x-token": token } }
    );

    const data = await res.json();
    console.log("📦 DISCOUNT DATA:", data);

    let slabsData = [];

    if (data.data?.subcategories?.length > 0) {
      slabsData = data.data.subcategories;
    } else if (data.data?.categories?.length > 0) {
      slabsData = data.data.categories;
    }

    if (data.success && slabsData.length > 0) {
      // ✅ STEP 1: Extract UNIQUE category ID from first slab
      const categoryId = slabsData[0].product_category_id;
      
      // ✅ STEP 2: FIRST fetch subcategories for this category
      await fetchSubCategories(categoryId);
      
      // ✅ STEP 3: Wait for subcategories to load, THEN create sections
        const sections = slabsData.map((item, index) => ({
          id: Date.now() + index,
          // ✅ ADD SUBCATEGORY INFO for display
          subCategoryName: getSubCategoryName(item.product_sub_category_id),
          subCategoryId: item.product_sub_category_id,
          categoryId: item.product_category_id,
          
          rows: (item.movs || []).map((movItem) => ({
            mov: movItem.mov || "",
            discount: movItem.discount || "",
            document_id: item._id,
            isExisting: true,
            attributeIds: item.attribute_value_ids || [],
            attributes: [],
          }))
        }));

        setSlabSections(sections);

        // ✅ STEP 4: Set category/subcategory selectors
        setSelectedCategory(categoryId);
        setSelectedSubCategory(slabsData[0].product_sub_category_id || "");

        // ✅ STEP 5: Load attributes
          fetchAttributesByCategory(categoryId, slabsData[0].product_sub_category_id);

    } else {
      setSlabSections([{
        id: Date.now(),
        rows: [getDefaultRow()]
      }]);
    }

  } catch (error) {
    console.error("Fetch discount error:", error);
    setSlabSections([{
      id: Date.now(),
      rows: [getDefaultRow()]
    }]);
  }finally {
    setIsDiscountLoading(false);
  }
};



const deletedRow = (sectionIndex, rowIndex) => {
  const row = slabSections[sectionIndex].rows[rowIndex];
  
  // 🟢 NEW ROW → direct delete
  if (!row.isExisting) {
    setSlabSections(prevSections =>
      prevSections.map((section, sIndex) =>
        sIndex === sectionIndex
          ? {
              ...section,
              rows: section.rows.filter((_, i) => i !== rowIndex)
            }
          : section
      )
    );
    return;
  }

  // 🔴 EXISTING ROW → confirm delete
  setDeleteConfirmed({
    show: true,
    sectionIndex,  // ✅ Add sectionIndex
    rowIndex
  });
};



const handleConfirmedDelete = async () => {
  const { sectionIndex, rowIndex } = deleteConfirmed;
  const section = slabSections[sectionIndex];
  const row = section.rows[rowIndex];

  try {
    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);

    const payload = {
      category_deletes: [{
        document_id: row.document_id,
        mov: row.mov
      }],
      subcategory_deletes: []
    };

    const res = await fetch(
      `${backendApiUrl}discount/delete-discountslabs`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify(payload)
      }
    );

    const data = await res.json();

    if (data.success) {
      // ✅ Remove from CORRECT SECTION immediately
      setSlabSections(prevSections =>
        prevSections.map((section, sIndex) =>
          sIndex === sectionIndex
            ? {
                ...section,
                rows: section.rows.filter((_, rIndex) => rIndex !== rowIndex)
              }
            : section
        )
      );
      
      setPopupMessage("Discount slab deleted successfully");
      setPopupType("200or201");
      setShowPopup(true);
    } else {
      setPopupMessage(data.message || "Delete failed");
      setPopupType("400");
      setShowPopup(true);
    }
  } catch (error) {
    console.error("Delete error:", error);
    setPopupMessage("Something went wrong");
    setPopupType("500");
    setShowPopup(true);
  }

  // ✅ Reset with sectionIndex & rowIndex
  setDeleteConfirmed({ 
    show: false, 
    sectionIndex: null,
    rowIndex: null 
  });
  setTimeout(() => setShowPopup(false), 2000);
};

const handleDiscountClick = () => {
  console.log("🟡 Discount clicked:", selectedSupplier?._id);

  // Set selectedVendor to selectedSupplier
  setSelectedVendor(selectedSupplier);

   setSelectedCategory("");
  setSelectedSubCategory("");
  setAttributes([]);
  setOpenDropdownIndex(null);

  setShowDiscountPopup(true);
  fetchProductCategories();
  fetchProductCategoriesOfSelectedVendor(selectedSupplier); // Pass supplier object
};


  return (
  <div className="h-screen bg-gray-50 flex flex-col">
    {/* Header - Fixed */}
    <div className="bg-white shadow-sm border-b flex-shrink-0">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div>
            <h1 className="text-xl font-semibold text-gray-900">Quick Buy Supplier Product Management</h1>
            <p className="text-sm text-gray-600 mt-1">Assign and manage products for suppliers across categories</p>
          </div>
          <div className="flex gap-3">
         {/*    <button className="bg-gray-100 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-200 flex items-center gap-2">
              <FontAwesomeIcon icon={faFilter} className="text-sm" />
              Export
            </button> */}
            <button className="bg-[#f7525a] text-white px-2 py-2 rounded-md hover:bg-[#f7525a] flex items-center gap-2"
            onClick={() => handleNavigateToCreateVendor()}>
              <FontAwesomeIcon icon={faPlus} className="text-sm" />
              Add Supplier
            </button>
          </div>
        </div>
      </div>
    </div>

    {/* Main Content Area - Takes remaining height */}
    <div className="flex-1 flex overflow-hidden">
      {/* Sidebar - Supplier Selection - Fixed Width */}
      <div className="w-80 bg-white shadow-sm border-r flex flex-col flex-shrink-0">
        {/* Supplier Header - Fixed */}
        <div className="px-4 py-2 border-b flex-shrink-0">
          <h3 className="text-lg font-medium text-gray-900 flex items-center gap-2">
            <FontAwesomeIcon icon={faUsers} className="text-blue-600" />
            Select Supplier
          </h3>
        </div>
        
        {/* Search Section - Fixed */}
        <div className="p-4 border-b flex-shrink-0">
          <div className="relative">
            <FontAwesomeIcon
              icon={faSearch}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"
            />
            <input
              type="text"
              placeholder="Search by name, company, mobile, item..."
              value={supplierSearchTerm}
              onChange={(e) => setSupplierSearchTerm(e.target.value)}
              className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {supplierSearchTerm && (
              <button
                onClick={clearSupplierSearch}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <FontAwesomeIcon icon={faX} className="text-sm" />
              </button>
            )}
          </div>
          {supplierSearchTerm && (
            <div className="mt-2 text-xs text-gray-500">
              Found {filteredSuppliers.length} supplier{filteredSuppliers.length !== 1 ? 's' : ''}
            </div>
          )}
        </div>

        {/* Suppliers List - Scrollable Only This Section */}
        <div className="flex-1  overflow-y-auto pb-12">
          <div className="p-2">
            <div className="space-y-2">
             {filteredSuppliers.length > 0 ? (
  filteredSuppliers.map((supplier, index) => (
    <div
      key={supplier._id}
      ref={el => supplierRefs.current[supplier._id] = el}
      onClick={() => handleSupplierSelect(supplier)}
      className={`p-3 rounded-lg cursor-pointer transition-all duration-200 border mb-3 ${
        selectedSupplier?._id === supplier._id
          ? 'bg-gray-100 border-gray-300 shadow-sm'
          : 'hover:bg-gray-50 border-gray-200 hover:border-gray-300'
      }`}
    >
      <div className="flex justify-between items-start">
        <div className="flex-1 min-w-0">
          <h4 className="font-medium text-gray-900 text-sm truncate">
            {supplier.company_name}
          </h4>
          <p className="text-xs text-gray-600 mt-1 truncate">{supplier.name}</p>
          <p className="text-xs text-gray-500 truncate">{supplier.email}</p>
        </div>
        <div className="flex-shrink-0 ml-2">
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
            supplier.is_active
              ? 'bg-green-100 text-green-800'
              : 'bg-red-100 text-red-800'
          }`}>
            {supplier.is_active ? 'Active' : 'Inactive'}
          </span>
        </div>
      </div>
      <div className="flex justify-between text-xs text-gray-500 mt-3 pt-2 border-t border-gray-100">
        <span
          className="flex items-center gap-1"
          title="Product categories assigned to this vendor"
        >
          <FontAwesomeIcon icon={faBox} />
          <span className="font-medium">{supplier.totalProductCategories || 0}</span>
          <span className="text-gray-400">Categories</span>
        </span>
        <span
          className="flex items-center gap-1"
          title="Total products assigned across all categories for this vendor"
        >
          <FontAwesomeIcon icon={faStore} />
          <span className="font-medium">{supplier.totalProducts || 0}</span>
          <span className="text-gray-400">Products</span>
        </span>
      </div>
    </div>
  ))
              ) : (
                <div className="text-center py-8">
                  <div className="text-gray-400 text-4xl mb-3">
                    <FontAwesomeIcon icon={faSearch} />
                  </div>
                  <p className="text-gray-500 text-sm">
                    {supplierSearchTerm ? 'No suppliers found matching your search' : 'No suppliers available'}
                  </p>
                  {supplierSearchTerm && (
                    <button
                      onClick={clearSupplierSearch}
                      className="mt-2 text-blue-600 text-sm hover:text-blue-800"
                    >
                      Clear search
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content - Right Side */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {selectedSupplier ? (
          <>
            {/* Selected Supplier Info - Fixed Header */}
<div className="bg-white shadow-sm border-b flex-shrink-0">
  <div className="px-6 py-4">
    <div className="flex justify-between items-start">
      <div className="flex items-start gap-4 flex-1 min-w-0">
        {/* Vendor Image */}
         {/* <div className="flex-shrink-0 relative group">
  {selectedSupplier.image ? (
    <>
      <div className="relative overflow-hidden rounded-lg">
        <img
          src={`${imageUrl}${selectedSupplier.image}`}
          alt={selectedSupplier.company_name}
          className="w-16 h-16 object-contain border-2 border-gray-200 bg-gray-50 cursor-pointer transition-all duration-300 group-hover:scale-110"
        />
      
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-200 flex items-center justify-center">
          <FontAwesomeIcon 
            icon={faSearch} 
            className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-sm"
          />
        </div>
      </div>
      
     
      <div className="absolute top-0 left-20 z-50 opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-95 group-hover:scale-100 pointer-events-none">
        <div className="bg-white border-2 border-gray-300 rounded-xl shadow-xl p-3">
          <img
            src={`${imageUrl}${selectedSupplier.image}`}
            alt={selectedSupplier.company_name}
            className="w-40 h-40 rounded-lg object-contain"
          />
          <div className="mt-2 text-center">
            <p className="text-sm font-medium text-gray-900 truncate">
              {selectedSupplier.company_name}
            </p>
            <p className="text-xs text-gray-500 truncate">
              {selectedSupplier.name}
            </p>
          </div>
        </div>
       
        <div className="absolute left-0 top-4 transform -translate-x-1 w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-white"></div>
      </div>
    </>
  ) : (
    <div className="w-16 h-16 rounded-lg bg-gray-200 flex items-center justify-center border-2 border-gray-200 group-hover:bg-gray-300 transition-colors duration-200 cursor-pointer">
      <FontAwesomeIcon icon={faUser} className="text-gray-400 text-xl group-hover:text-gray-500 transition-colors duration-200" />
    </div>
  )}
</div> */}
     {/* Vendor Image */}
<div className="flex-shrink-0 relative group">
  {selectedSupplier.image ? (
    <>
      <div className="relative overflow-hidden rounded-lg">
        <img
          src={`${imageUrl}${selectedSupplier.image}`}
          alt={selectedSupplier.company_name}
          className="w-16 h-16 object-contain border-2 border-gray-200 bg-gray-50 cursor-pointer transition-all duration-300 group-hover:scale-110"
        />
        {/* Magnifying glass icon overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-200 flex items-center justify-center">
          <FontAwesomeIcon
            icon={faSearch}
            className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-sm"
          />
        </div>
      </div>
           
      {/* Large preview on hover - Responsive sizing */}
      <div className="absolute top-0 left-20 z-50 opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-95 group-hover:scale-100 pointer-events-none">
        <div className="bg-white border-2 border-gray-300 rounded-xl shadow-xl p-3 
                        w-48 sm:w-56 md:w-64 lg:w-72 xl:w-80
                        max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg">
          <div className="w-full aspect-square overflow-hidden rounded-lg bg-gray-50 flex items-center justify-center">
            <img
              src={`${imageUrl}${selectedSupplier.image}`}
              alt={selectedSupplier.company_name}
              className="max-w-full max-h-full object-contain"
            />
          </div>
          <div className="mt-3 text-center px-2">
            <p className="text-sm font-medium text-gray-900 line-clamp-2 leading-tight">
              {selectedSupplier.company_name}
            </p>
            <p className="text-xs text-gray-500 mt-1 line-clamp-1">
              {selectedSupplier.name}
            </p>
          </div>
        </div>
        {/* Arrow pointing to original image */}
        <div className="absolute left-0 top-4 transform -translate-x-1 w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-white"></div>
      </div>
    </>
  ) : (
    <div className="w-16 h-16 rounded-lg bg-gray-200 flex items-center justify-center border-2 border-gray-200 group-hover:bg-gray-300 transition-colors duration-200 cursor-pointer">
      <FontAwesomeIcon icon={faUser} className="text-gray-400 text-xl group-hover:text-gray-500 transition-colors duration-200" />
    </div>
  )}
</div>


        
        {/* Vendor Details */}
        <div className="flex-1 min-w-0">
          <h2 className="text-xl font-semibold text-gray-900 truncate">{selectedSupplier.company_name}</h2> 
          <div className="flex items-center gap-4 mt-2 text-sm text-gray-500 flex-wrap">
            {/*  <span className="truncate">{selectedSupplier.email}</span>  */}
            <span className="truncate">{selectedSupplier.mobile_number}</span>
            <span className="truncate">{selectedSupplier.address}</span>
          </div>
        </div>
      </div>
      
      <div className="flex items-center gap-3 flex-shrink-0 ml-4">
        <span className={`px-3 py-1 rounded-full text-sm font-medium ${
          selectedSupplier.is_active
            ? 'bg-green-100 text-green-800'
            : 'bg-red-100 text-red-800'
        }`}>
          {selectedSupplier.is_active ? 'Active' : 'Inactive'}
        </span>
        <button className="text-gray-400 hover:text-gray-600"
        onClick={handleEditSupplier}>
          <FontAwesomeIcon icon={faEdit} />
        </button>
      </div>
    </div>
  </div>
</div>


            {/* Filters - Fixed Header */}
            <div className="bg-white border-b flex-shrink-0">
              <div className="p-4">
                <div className="flex flex-col sm:flex-row gap-4">
                  <div className="flex-1">
                    <div className="relative">
                      <FontAwesomeIcon
                        icon={faSearch}
                        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"
                      />
                      <input
                        type="text"
                        placeholder="Search product categories..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                  </div>
                  <div className="flex items-center text-sm text-gray-600">
                    {filteredCategories.length} categor{filteredCategories.length !== 1 ? 'ies' : 'y'}
                  </div>
                </div>
              </div>
            </div>

            {/* Product Categories Grid - Scrollable Only This Section */}
            <div className="flex-1 overflow-y-auto bg-gray-50 pb-12">
                <div className="p-6">
                {filteredCategories.length > 0 ? (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
  {filteredCategories.map(category => {
    const assignedCount = getAssignedProductsCount(category._id);
    const totalCount = category.total_products_count || 0;
    const progressPercentage = totalCount > 0 ? (assignedCount / totalCount) * 100 : 0;
    
    // Check if this category is assigned to the selected supplier
    const isCategoryAssignedToSupplier = selectedSupplier?.productCategories?.some(
      supplierCategory => supplierCategory._id === category._id
    );

    
    return (
      <div key={category._id} className="bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow ">
        <div className="p-4">
          <div className="mb-4">
         <div className="flex items-center justify-between mb-2">
  {/* Category Name - LEFT */}
  <h3 className="text-sm font-semibold text-gray-900 max-w-[90%] truncate">
    {category.product_category_name}
  </h3>

  {/* RIGHT SIDE BUTTONS */}
  <div className="flex items-center gap-2">
    
    {/* MOV Button */}
    {/* <button
      disabled={!isCategoryAssignedToSupplier}
      onClick={() => handleMovsClick(category)}
      className={`px-3 py-1 text-[10px] rounded-md font-medium flex items-center justify-center gap-1
        ${
          isCategoryAssignedToSupplier
            ? 'bg-red-500 text-white hover:bg-red-500'
            : 'bg-gray-200 text-gray-400 cursor-not-allowed'
        }`}
    >
      <FontAwesomeIcon icon={faPlus} className="text-xs" />
      <span>MOV</span>
    </button> */}

    {/* Discount Button */}
    {/* <button
      disabled={!isCategoryAssignedToSupplier}
      onClick={handleDiscountClick}
      className={`px-2 py-1 text-[10px] rounded-md font-medium shadow-sm border
        ${
          isCategoryAssignedToSupplier
            ? 'bg-red-500 text-white hover:bg-red-500'
            : 'bg-gray-200 text-gray-400 cursor-not-allowed'
        }`}
    >
      Discount
    </button> */}

  </div>
</div>

            
            {/* Progress Bar */}
            <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
              <div
                className="bg-green-500 h-2 rounded-full transition-all duration-300"
                style={{ width: `${progressPercentage}%` }}
              ></div>
            </div>
            
            <div className="text-xs text-gray-500">
              {progressPercentage.toFixed(1)}% assigned
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-3 mb-4">
            <div className="text-center bg-gray-50 rounded-lg p-2">
              <div className="text-lg font-bold text-blue-600">{totalCount}</div>
              <div className="text-xs text-gray-600">Total</div>
            </div>
            <div className="text-center bg-gray-50 rounded-lg p-2">
              <div className="text-lg font-bold text-green-600">{assignedCount}</div>
              <div className="text-xs text-gray-600">Assigned</div>
            </div>
          </div>
          
          {/* Conditional Button Rendering */}
          {isCategoryAssignedToSupplier ? (
            // Show Assign and View buttons when category is assigned to supplier
            <div className="flex gap-2">
              <button
                onClick={() => handleAssignProducts(category)}
                disabled={totalCount === 0 || totalCount - assignedCount === 0}
                title={
                  totalCount === 0
                    ? "Add products to this category"
                    : totalCount - assignedCount === 0
                      ? "All products in this category are already assigned"
                      : "Assign products to supplier"
                }
                className={`flex-1 px-2 py-1.5 rounded-md flex items-center justify-center gap-1 text-xs font-medium transition-colors ${
                  totalCount === 0 || totalCount - assignedCount === 0
                    ? 'bg-[#fbb4b7] text-white cursor-not-allowed'
                    : 'bg-[#f7525a] text-white hover:bg-[#e54643]'
                }`}
              >
                <FontAwesomeIcon icon={faPlus} className="text-xs" />
                Assign
              </button>
              
              <button
                onClick={() => handleViewProducts(category)}
                disabled={assignedCount === 0}
                className={`flex-1 px-2 py-1.5 rounded-md flex items-center justify-center gap-1 text-xs font-medium transition-colors ${
                  assignedCount > 0
                    ? 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    : 'bg-gray-50 text-gray-400 cursor-not-allowed'
                }`}
              >
                <FontAwesomeIcon icon={faEye} className="text-xs" />
                View ({assignedCount})
              </button>
            </div>
          ) : (
            // Show "Assign Category to Supplier" button when category is not assigned to supplier
            <div className="flex">
              <button
                onClick={() => handleAssignCategoryToSupplier(category)}
                className="w-full bg-blue-600 text-white px-3 py-2 rounded-md hover:bg-blue-700 flex items-center justify-center gap-2 text-xs font-medium transition-colors shadow-sm"
                title="First assign this category to the supplier to enable product management"
              >
                <FontAwesomeIcon icon={faUserPlus} className="text-xs" />
                <span className="font-semibold">Assign Category to Supplier</span>
              </button>
            </div>
          )}
          
          {/* Optional: Show status indicator */}
         {/*  {!isCategoryAssignedToSupplier && (
            <div className="mt-2 text-center">
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                <FontAwesomeIcon icon={faExclamationTriangle} className="mr-1 text-xs" />
                Category not assigned to supplier
              </span>
            </div>
          )} */}
        </div>
      </div>
    );
  })}
</div>

                ) : (
                  <div className="bg-white rounded-lg shadow-sm border">
                    <div className="text-center py-12">
                      <div className="text-gray-400 text-5xl mb-4">
                        <FontAwesomeIcon icon={faSearch} />
                      </div>
                      <h3 className="text-lg font-medium text-gray-900 mb-2">No categories found</h3>
                      <p className="text-gray-600">
                        {searchTerm 
                          ? 'Try adjusting your search criteria or clear the search to see all categories'
                          : 'No product categories are available for this supplier'
                        }
                      </p>
                      {searchTerm && (
                        <button
                          onClick={() => setSearchTerm('')}
                          className="mt-4 text-blue-600 hover:text-blue-800 font-medium"
                        >
                          Clear search
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="flex-1 flex items-center justify-center bg-gray-50">
            <div className="bg-white rounded-lg shadow-sm border p-12 max-w-md mx-auto">
              <div className="text-center">
                <div className="text-gray-400 text-6xl mb-4">
                  <FontAwesomeIcon icon={faUsers} />
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">Select a Supplier</h3>
                                <p className="text-gray-600">Choose a supplier from the sidebar to manage their product categories</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>

    {/* Modals */}
    {showAssignModal && (
      <AssignProductsModal
        supplier={selectedSupplier}
        category={selectedCategory}
        onClose={() => setShowAssignModal(false)}
        onAssignmentComplete={handleAssignmentComplete}
        existingAssignments={null}
        CategoryProducts={PC_Products}
      />
    )}

    {showViewModal && (
      <ViewAssignedProducts
        supplier={selectedSupplier}
        category={selectedCategory}
        onClose={() => setShowViewModal(false)}
        assignedProducts={supplierCategoryProducts}
        onProductUpdate={handleUpdateViewAssignedProducts}
        onProductRemove={handleRemoveAssignedProduct}
      />
    )}

    {showAssignCategoryPopup && categoryToAssign && selectedSupplier && (
  <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-b-md shadow-md w-[550px] h-[250px] flex flex-col" style={{ maxWidth: '550px', maxHeight: '250px' }}>
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-14 px-6'>
        <h2 className="text-md font-semibold">
          <FontAwesomeIcon icon={faInfoCircle} className="text-xl text-gray-500 mr-4" />
          Assign Category to Supplier?
        </h2>
        <button onClick={handleCancelAssignCategory} className="text-white px-1 py-1 rounded-md">   
          <FontAwesomeIcon icon={faX} className="text-xs text-[#212529] cursor-pointer" />
        </button>
      </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className='pt-4 pl-4'>
        <div className="w-full items-center p-5">
          <label className="block text-sm font-regular text-[#212529]">
            Are you sure you want to assign <span className="font-semibold text-blue-600">"{categoryToAssign.product_category_name}"</span> category to supplier <span className="font-semibold text-green-600">"{selectedSupplier.name}"</span>?
          </label>
        </div>  
      </div>
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
         {/*  <button 
            className="px-4 py-2 bg-[#408dfb] text-white rounded-md hover:bg-[#357abd] transition-colors"
            onClick={handleConfirmAssignCategory}
          >
            Yes, Assign
          </button> */}
          <button 
  className="px-4 py-2 bg-[#408dfb] text-white rounded-md hover:bg-[#357abd] transition-colors disabled:opacity-50"
  onClick={handleConfirmAssignCategory}
  disabled={isSaving}
>
  {isSaving ? (
    <>
      <span className="mr-2">Assigning...</span>
      {/* Add your Spinner component here if you have one */}
    </>
  ) : (
    'Yes, Assign'
  )}
</button>

          <button 
            onClick={handleCancelAssignCategory} 
            className="hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-4 py-2 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md hover:bg-gray-200 transition-colors"
          >
            No, Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
)}


{showMovsPopup && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
    <div
      className="relative bg-white rounded-lg shadow-xl flex flex-col"
      style={{ width: '70%', height: '80%' }}
    >
      {/* Header */}
      <div className="flex justify-between items-center px-6 py-3 border-b">
        <div>
          <h2 className="text-lg font-semibold">Setup MOV For Category</h2>
          <p className="text-sm text-gray-600">
            Supplier:{" "}
            <span className="text-blue-600 font-medium">
              {selectedSupplier?.name}
            </span>
          </p>
        </div>
        <button
          onClick={() => setShowMovsPopup(false)}
          className="absolute top-4 right-5 text-red-600"
        >
          <FontAwesomeIcon icon={faX} />
        </button>
      </div>

      {/* Body */}
      <div className="flex-1 overflow-y-auto px-6 py-4">
       
        <div className="border rounded-lg p-4">
          {/* Category Header */}
          <div className="flex justify-between items-center mb-4">
            <span className="font-medium text-gray-800">
              {movsCategory?.product_category_name}
            </span>

       <button
  onClick={addRow}
  className="flex items-center gap-1 px-3 py-2 text-xs bg-blue-600 text-white rounded-md"
>
  {/* <FontAwesomeIcon icon={faPlus} /> */}
  Add MOV
</button>

          </div>

          {/* Table */}
      {rows.length > 0 && subCategories.length > 0 && (
  <div className="rounded-md overflow-x-auto mt-4">
    <table className="w-full border-collapse text-sm">
      <thead className="bg-gray-100">
        <tr>
          <th className="border px-3 py-2 w-12"></th>
          <th className="border px-3 py-2 text-center font-medium">MOV</th>
          <th className="border px-3 py-2 text-center">
  <div className="flex flex-col items-center leading-tight">
    <span className="text-sm font-medium">
      Category Level
    </span>
    <span className="text-xs font-medium">
      Discount (%)
    </span>
  </div>
</th>

<th className="border px-3 py-2 text-center">
  <div className="flex flex-col items-center leading-tight">
    <span className="text-sm font-medium">
      SubCategory Level
    </span>
    <span className="text-xs font-medium">
      Discount (%)
    </span>
  </div>
</th>

        </tr>
      </thead>

      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {/* Checkbox */}
           <td className="border px-2 py-2 text-center">
      <button
  onClick={() => {
    if (!row._categoryMovId) {
      setRows(prev => prev.filter((_, i) => i !== rowIndex));
    } else {
      setDeleteRowIndex(rowIndex);
      setShowDeleteConfirm(true);
    }
  }}
  className="text-red-600 hover:text-red-800"
>
  <FontAwesomeIcon icon={faTrash} />
</button>

      </td>

            {/* Range */}
           <td className="border px-2 py-2 text-center align-middle">
<input
  value={row.mov}
  onChange={(e) => {
    const value = e.target.value;
    setRows(prev =>
      prev.map((r, i) =>
        i === rowIndex ? { ...r, mov: value } : r
      )
    );
  }}
  className="w-20 border rounded px-2 py-1 text-sm text-center"
/>

</td>

            {/* Discount */}
       <td className="border px-2 py-1 text-center align-middle">
  <div className="flex items-center justify-center gap-2">
    <input
      type="number"
      value={row.category_discount}
      onChange={(e) => {
        const value = e.target.value;
        setRows(prev =>
          prev.map((r, i) =>
            i === rowIndex ? { ...r, category_discount: value, applied: false } : r  
          )
        );
      }}
      className="w-24 border rounded px-2 py-1 text-sm text-center"
    />
    {row.category_discount !== '' && row.category_discount !== null && row.category_discount !== 0 && (
      <button
        onClick={() => handleApply(rowIndex)}
        className={`px-2 py-1 text-xs rounded ${row.applied ? 'bg-gray-400 text-white' : 'bg-green-600 text-white'}`}
      >
        {row.applied ? 'Applied' : 'Apply'}
      </button>
    )}
  </div>
</td>

            {/* Subcategories */}
          <td className="border px-2 py-2 text-center align-middle">
  <div className="flex flex-col gap-3 items-center"> {/* add items-center */}
    {subCategories.map((subCat) => (
      <div
        key={subCat._id}
        className="grid grid-cols-[1fr_80px] items-center gap-3"
        style={{ minWidth: '200px' }} // optional: to prevent very narrow grid
      >
        <span className="text-sm whitespace-normal break-words text-left">
          {subCat.product_sub_category_name}
        </span>

<input
  type="number"
  value={row.subcategory_discounts?.[subCat._id] || 0} 
  onChange={(e) => {
    const value = e.target.value;
    setRows(prev =>
      prev.map((r, i) =>
        i === rowIndex
          ? {
              ...r,
              subcategory_discounts: {
                ...r.subcategory_discounts,
                [subCat._id]: Number(value)
              }
            }
          : r
      )
    );
  }}
  className="w-20 border rounded px-2 py-1 text-xs text-center"
/>

      </div>
    ))}
  </div>
</td>


           
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}

        </div>
      </div>

      {/* Footer */}
      <div className="flex justify-end gap-3 px-6 py-3 border-t">
        <button
          onClick={() => setShowMovsPopup(false)}
          className="px-4 py-2 text-sm border rounded-md"
        >
          Close
        </button>
      <button
        onClick={handleSave}
        className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md"
      >
        Save changes
      </button>
      </div>
    </div>
  </div>
)}

{showDeleteConfirm && (
  <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50">
    <div className="bg-white rounded-md shadow-lg w-[400px]">
      
      {/* Header */}
      <div className="px-5 py-3 border-b flex justify-between items-center">
        <h3 className="text-md font-semibold text-gray-800">
          Confirm Delete
        </h3>
        <button
          onClick={() => setShowDeleteConfirm(false)}
          className="text-gray-500 hover:text-gray-700"
        >
          <FontAwesomeIcon icon={faX} />
        </button>
      </div>

      {/* Body */}
      <div className="px-5 py-6 text-sm text-gray-700">
        Are you sure you want to delete this MOV?
      </div>

      {/* Footer */}
      <div className="px-5 py-3  flex justify-center gap-3">
        <button
          onClick={() => {
            setShowDeleteConfirm(false);
            setDeleteRowIndex(null);
          }}
          className="px-4 py-2 text-sm border rounded-md"
        >
          No
        </button>

        <button
          onClick={() => {
            deleteRow(deleteRowIndex);
            setShowDeleteConfirm(false);
            setDeleteRowIndex(null);
          }}
          className="px-4 py-2 text-sm bg-red-600 text-white rounded-md hover:bg-red-700"
        >
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
)}

{showDiscountPopup && (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">


<div className="bg-white w-[900px] max-h-[90vh] flex flex-col rounded-xl shadow-xl">  
       <div className="px-6 py-4 border-b bg-gray-50">

  {/* First Line */}
  <h2 className="text-lg font-semibold text-gray-800">
    Set Discount Slabs
  </h2>

  {/* Second Line */}
  <div className="flex justify-between items-center">
   <span className="text-sm text-gray-600">
  Brand :{" "}
 <span className="font-medium text-blue-600">
  {selectedVendor?.name}
</span>
</span>

    <button
      onClick={() => setShowDiscountPopup(false)}
      className="text-gray-500 hover:text-red-500 hover:font-medium text-lg -mt-10"
    >
      ✕
    </button>
  </div>

</div>

      {/* Body */}
<div className="p-6 bg-white sticky top-0 z-20">

  {isDiscountLoading ? (
 <div className="flex justify-center items-center h-40">
    <div className="w-8 h-8 border-4 border-red-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
) : (
  <>

{/* PRODUCT CATEGORY */}
<div className="flex items-center mb-6">

  <label className="w-40 text-sm font-semibold text-gray-700">
    Product Category
  </label>

<select
  value={selectedCategory}
 onChange={(e) => {
  const value = e.target.value;

  // 🔥 SAVE CURRENT BEFORE SWITCH
  if (selectedVendor && selectedCategory) {
    setSavedSlabs(prev => ({
      ...prev,
      [selectedVendor._id]: {
        ...prev[selectedVendor._id],
        [selectedCategory]: {
          ...prev[selectedVendor._id]?.[selectedCategory],

          // ✅ SAVE BASED ON TYPE
          ...(selectedSubCategory
            ? {
                [selectedSubCategory]: slabSections  
              }
            : {
                "__category__": slabSections         
              })
        }
      }
    }));
  }

  // ✅ SET NEW CATEGORY
  setSelectedCategory(value);
  setSelectedSubCategory("");

  // 🔥 RESTORE CATEGORY DATA IF EXISTS
  const restoredCategoryData =
    savedSlabs?.[selectedVendor?._id]?.[value]?.["__category__"];

  if (restoredCategoryData) {
    setSlabSections(restoredCategoryData);
  } else {
    setSlabSections([{
      id: Date.now(),
      rows: [getDefaultRow()]
    }]);
  }

  // ✅ RESET OTHER STATES
  setAttributes([]);
  setOpenDropdownIndex(null);

  // ✅ API CALLS
  if (value) {
    fetchAttributesByCategory(value, null);
    fetchSubCategories(value);
  }
}}
  className="w-64 border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none"
>
    <option value="">Select Category</option>

    {categories
      .filter(cat => vendorCategories.includes(cat._id))
      .map(cat => (
        <option key={cat._id} value={cat._id}>
          {cat.product_category_name}
        </option>
      ))}
  </select>

</div>

{/* PRODUCT SUBCATEGORY */}
<div className="flex items-center mb-6">

  <label className="w-40 text-sm font-semibold text-gray-700">
    Product Subcategory
  </label>

 <select
  value={selectedSubCategory}
onChange={(e) => {
  const subId = e.target.value;

  // 🔥 SAVE CURRENT DATA
  if (selectedVendor && selectedCategory) {
    setSavedSlabs(prev => ({
      ...prev,
      [selectedVendor._id]: {
        ...prev[selectedVendor._id],
        [selectedCategory]: {
          ...prev[selectedVendor._id]?.[selectedCategory],

          ...(selectedSubCategory
            ? {
                [selectedSubCategory]: slabSections  
              }
            : {
                "__category__": slabSections          
              })
        }
      }
    }));
  }

  // ✅ SET SUBCATEGORY
  setSelectedSubCategory(subId);

  let restored;

  if (!subId) {
    restored =
      savedSlabs?.[selectedVendor?._id]?.[selectedCategory]?.["__category__"];
  } else {
    restored =
      savedSlabs?.[selectedVendor?._id]?.[selectedCategory]?.[subId];
  }

  if (restored) {
    setSlabSections(restored);
  } else {
    setSlabSections([{
      id: Date.now(),
      rows: [getDefaultRow()]
    }]);
  }

  setAttributes([]);
  setOpenDropdownIndex(null);

  fetchAttributesByCategory(selectedCategory, subId || null);
}}
  className="w-64 border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none"
>
  <option value="">Select Subcategory</option>

  {subCategories.map(sub => (
    <option key={sub._id} value={sub._id}>
      {/* Note: Check if your data uses subcategory_name or product_sub_category_name */}
      {sub.product_sub_category_name || sub.subcategory_name} 
    </option>
  ))}
</select>

</div>

<div className="flex justify-end mb-3">
  <button
    onClick={handleAddSlabSection}
    className="border border-gray-200 bg-gray-200 text-black px-4 py-2 rounded-md text-sm"
  >
    + Discount Slab
  </button>
</div>

<div className="max-h-[300px] overflow-y-auto pr-2 mb-8">


{slabSections.map((section, sectionIndex) => (
<div key={section.id} className="mb-2 border border-gray-300 rounded-md">
  {/* SINGLE BORDER CONTAINER */}
<div className="border border-gray-200 rounded-md overflow-visible">
    {/* HEADER */}
  <div className="px-4 py-2 border-b border-gray-200 flex items-center gap-2">

  {/* TEXT */}
  <h3 className="text-sm font-semibold text-gray-700">
     Discount Slab
  </h3>

  {/* DROPDOWN */}
  {/* DROPDOWN TRIGGER - FIXED INDEXING */}
<div 
  ref={(el) => (buttonRefs.current[sectionIndex] = el)}
  className="relative"
>
  <button
    type="button"
    onClick={(e) => {
      e.stopPropagation();
      
      // ✅ BULLETPROOF POSITIONING - Direct calculation, NO useEffect
      const button = buttonRefs.current[sectionIndex];
      if (button) {
        const rect = button.getBoundingClientRect();
        setDropdownStyle({
          top: rect.bottom + window.scrollY + 5,
          left: rect.left + window.scrollX
        });
      }
      
      // ✅ BULLETPROOF TOGGLE - Functional update prevents stale state
   setOpenDropdownIndex(prev =>
  prev === sectionIndex ? null : sectionIndex
);
    }}
    className="text-sm flex items-center gap-2 px-2 py-1 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
  >
    <FontAwesomeIcon 
      icon={faSliders} 
      className="text-gray-600 text-xs" 
    />
   <span className="text-xs font-medium">
  {slabSections[sectionIndex]?.rows?.some(row => row.attributes?.length > 0)
    ? `${[...new Map(
        slabSections[sectionIndex]?.rows
          ?.flatMap(row => row.attributes || [])
          .map(attr => [attr.id, attr])
      ).values()].length} attrs`
    : 'Select attrs'
  }
</span>
    {/* <FontAwesomeIcon 
  icon={faChevronDown} 
  className={`text-xs transition-transform ${
    openDropdownIndex?.sectionIndex === sectionIndex ? 'rotate-180' : ''
  }`} 
/> */}
  </button>
</div>

  {/* SELECTED ATTRIBUTES */}
{/* ✅ FIXED: Show ONLY VALUES (No Names) */}
<div className="flex gap-2 ml-auto items-center max-w-[550px] overflow-hidden">
  {(() => {
const targetSectionIndex = sectionIndex;
    const sectionRows = slabSections[targetSectionIndex]?.rows || [];
    
    // ✅ Get UNIQUE attribute VALUES only (no names)
    const allSectionValues = [
      ...new Map(
        sectionRows
          .flatMap(r => r.attributes || [])
          .map(a => [a.id, a.name])  // ✅ Use 'name' which is the VALUE
      ).values()
    ];

    return (
      <>
        {/* ✅ Show first 5 VALUES ONLY */}
        {allSectionValues.slice(0, 5).map((value, i) => (
          <span
            key={i}
            className="text-xs text-gray-700 bg-emerald-100 border border-emerald-200 px-2 py-0.5 rounded-md whitespace-nowrap"
          >
            {value}  {/* ✅ VALUE ONLY */}
          </span>
        ))}
        
        {/* ✅ +more count */}
        {allSectionValues.length > 5 && (
          <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded">
            +{allSectionValues.length - 5} more
          </span>
        )}
      </>
    );
  })()}
</div>

</div>
    {/* TABLE */}
<div className="">
          <table className="w-full border-collapse text-sm">

        {/* HEADER */}
      <thead className="bg-gray-100 sticky top-0 z-10">
          <tr>
            <th className="border px-4 py-2 w-12"></th>

            <th className="border px-4 py-2 text-center font-medium">
              Order Value
            </th>

            <th className="border px-3 py-2 text-center">
              <div className="flex flex-col items-center leading-tight">
                <span className="text-sm font-medium">
                  Discount
                </span>
              </div>
            </th>
          </tr>
        </thead>

        {/* BODY */}
        <tbody>
         {section.rows.map((row, rowIndex) => (
           <tr key={rowIndex}>
              
              {/* DELETE */}
              <td className="border px-2 py-2 text-center">
                <button
                 onClick={() => deletedRow(sectionIndex, rowIndex)}
                  className="text-gray-600 hover:text-red-600"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </td>

              {/* MOV */}
              <td className="border px-2 py-4 text-center">
              <input
  type="text"
  placeholder="Order Value"
  value={row.mov}
  onChange={(e) => handleRowChange(sectionIndex, rowIndex, 'mov', e.target.value)}
  className="w-28 border rounded-md px-4 py-1 text-sm text-center"
/>

              </td>

              {/* ATTRIBUTE DISCOUNT */}
    <td className="border px-2 py-4 relative">
  <div className="flex justify-center">
    <div className="flex items-start gap-6 relative">

      <div className="relative">
     
       
      </div>

      {/* RIGHT SIDE */}
      <div className="flex flex-col gap-2">
  <input
    type="text"
    placeholder="%"
    value={row.discount || ""}
   onChange={(e) => handleRowChange(sectionIndex, rowIndex, 'discount', e.target.value)}
    className="w-24 border rounded-md px-3 py-1 text-sm text-center"
  />

      </div>

    </div>
  </div>
</td>



            </tr>
          ))}
        </tbody>

      </table>
    </div>

  </div>


  {/* ADD ROW */}
 <button
  onClick={() => addRow(sectionIndex)}
  className="text-blue-500 mt-2 mb-2 ml-2 px-3 py-1 rounded-md text-sm font-medium"
>
  + Add Row
</button>
</div>
))}
</div>

      {/* Footer */}
        <div className="px-4 py-3 border-t flex justify-end gap-2 bottom-0 sticky pb-0">
        <button
          onClick={() => setShowDiscountPopup(false)}
          className="px-4 py-1 border rounded"
        >
          Cancel
        </button>

       <button
  onClick={handleSaveDiscountSlabs}
  className="px-4 py-1 bg-blue-600 text-white rounded"
>
  Save Changes
</button>
      </div>
</>
  )}
    </div>
  </div>
  </div>
)}


{deleteConfirmed.show && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="bg-white rounded-lg p-5 w-[300px] shadow-lg">
      
      <h3 className="text-md font-semibold mb-3">
        Confirm Delete
      </h3>

      <p className="text-sm text-gray-600 mb-4">
        Are you sure you want to delete this discount slab?
      </p>

      <div className="flex justify-end gap-2">
        <button
          onClick={() => setDeleteConfirmed({ show: false, index: null })}
          className="px-3 py-1 border rounded"
        >
          Cancel
        </button>

        <button
          onClick={handleConfirmedDelete}
          className="px-3 py-1 bg-red-600 text-white rounded"
        >
          Delete
        </button>
      </div>

    </div>
  </div>
)}

{openDropdownIndex?.sectionIndex !== null && attributes.length > 0 && (
  <div
className="fixed z-[9999] w-56 max-h-72 bg-white overflow-y-auto"    style={dropdownStyle}
    onClick={(e) => e.stopPropagation()}
  >
    {(() => {
const targetSectionIndex = openDropdownIndex;      
      if (targetSectionIndex === null || 
          targetSectionIndex >= slabSections.length || 
          !slabSections[targetSectionIndex]) {
        return null;
      }

const filteredAttributes = attributes.filter(attr =>
  !selectedSubCategory || 
  String(attr.product_sub_category_id) === String(selectedSubCategory)
);
if (filteredAttributes.length === 0) {
  return (
    <div className="p-2 text-sm text-gray-400">
      No attributes
    </div>
  );
}

      return filteredAttributes.flatMap((attr) =>
        (attr.attribute_values || [])
          .filter(val => val.attribute_value && val.attribute_value.trim() !== '')
          .map((val) => (
            <label
              key={val.attribute_value_id}
className="flex items-center gap-3 px-2 py-1 hover:bg-blue-50 cursor-pointer border-b border-gray-100"            >
              <input
                type="checkbox"
                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 flex-shrink-0"
                checked={
                  slabSections[targetSectionIndex]?.rows?.some(row => 
                    row.attributes?.some(a => a.id === val.attribute_value_id)
                  ) || false
                }
            onChange={() => {
  setSlabSections(prevSections =>
    prevSections.map((section, sIndex) =>
      sIndex === targetSectionIndex
        ? {
            ...section,
            rows: section.rows.map((row) =>  // ✅ REMOVED rIndex CONDITION
              (() => {
                const currentAttrs = row.attributes || [];

                let updatedAttrs;

                if (currentAttrs.some(a => a.id === val.attribute_value_id)) {
                  updatedAttrs = currentAttrs.filter(
                    a => a.id !== val.attribute_value_id
                  );
                } else {
                  updatedAttrs = [
                    ...currentAttrs,
                    {
                      id: val.attribute_value_id,
                      name: val.attribute_value
                    }
                  ];
                }

                return {
                  ...row,
                  attributes: updatedAttrs,
                  attributeIds: updatedAttrs.map(a => a.id) // ✅ IMPORTANT FIX
                };
              })()
            )
          }
        : section
    )
  );
}}
              />
              {/* ✅ ONLY VALUE - NO ATTRIBUTE NAME */}
              <div className="flex-1 min-w-0">
                <span className="text-sm font-medium text-gray-900 truncate block">
                  {val.attribute_value}  {/* ✅ Value only */}
                </span>
                {/* ✅ REMOVED: attr.attribute_name */}
              </div>
            </label>
          ))
      );
    })()}
  </div>
)}

  {showPopup && (
  <div style={{ zIndex: 9999 }}>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
    {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
    {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
    {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}
  </div>
);


};

export default SupplierProductDashboard;

